import styles from './deleteModal.module.scss';
import Modal from '../../../../components/modal/Modal';
import Button from '../../../../components/button/Button';
import Spinner from '@src/components/spinner/Spinner';

type Props = {
  open: boolean;
  loading: boolean;
  onClose: () => void;
  onDelete: () => void;
};

function DeleteModal(props: Props) {
  const { open, loading, onClose, onDelete } = props;

  const handleClose = () => {
    onClose();
  };

  const handleDelete = () => {
    onDelete();
  }

  return (
    <Modal open={open} onClose={handleClose} className={styles.wrapper}>
      <div>
        <div className={styles.title}>Delete Course</div>
          <div className={styles.content}>
            <div className={styles.action}>
              <Button className={styles.cancelButton} disabled={loading} onClick={handleClose} label={'CANCEL'}/>
              <Button className={styles.deleteButton} disabled={loading} onClick={handleDelete} label={'CONFIRM DELETION'} leftIcon={loading ? <Spinner width={20} height={20} /> : undefined}/>
            </div>
          </div>
      </div>
    </Modal>
  );
}

export default DeleteModal;
